export const playerReport = {
  playerReport: "Player Report",
  search: "Search",
  advanceFilter: "Advance Filter",
  user: "User",
  providerName: "Provider Name",
  cancel: "Cancel",
  filter: "Filter",
  exportReport: "Export Report",
  totalBetRounds: "TOTAL BET ROUNDS",
  betAmount: "BET AMOUNT",
  validBetAmount: "VALID BET AMOUNT",
  winloss: "WIN/LOSS",
  winlossPercent: "WIN/LOSS %",
  date: "DATE",
};
